import { postFetch } from '../fetch';

import { apiConfig } from '../config';

export function deleteQuiz(quizId: string): Promise<void> {
    const { apiDeleteQuiz } = apiConfig.getStaticUrls();

    return postFetch(`${apiDeleteQuiz}${quizId}/`);
}
